import { reactive } from "vue";

export const notifications = reactive({
  items: [],
  unread: 0,

  add(note) {
    const now = new Date();
    this.items.unshift({
      ...note,
      id: Date.now() + Math.random(),
      read: false, // for menu / unread count
      showToast: true, // for floating alert
      date: note.date || now.toLocaleDateString(),
      time:
        note.time ||
        now.toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" }),
    });
    this.unread++;
  },

  markAllRead() {
    this.items.forEach((n) => {
      n.read = true; // mark as read for bell/unread count
      n.showToast = false; // hide the toast alert
    });
    this.unread = 0;
  },

  markRead(id) {
    const note = this.items.find((n) => n.id === id);
    if (note && !note.read) {
      note.read = true;
      this.unread = Math.max(0, this.unread - 1);
    }
  },

  hideToast(id) {
    const note = this.items.find((n) => n.id === id);
    if (note) {
      note.showToast = false;
    }
  },

  clear() {
    this.items = [];
    this.unread = 0;
  },
});
